import AppConfig, { Environments } from './AppConfig';

const getEnvironment = (): Environments | '' =>
  (process.env.REACT_APP_ENV as Environments) ||
  (AppConfig &&
    `${Object.keys(AppConfig).find((env) =>
      AppConfig[env as Environments].APP_URLS.some((url) => new URL(url).hostname === window.location.hostname),
    )}`) ||
  '';

export default getEnvironment;
